export const px2em = (px) => {
  return px;
};

export default px2em;



// WEBPACK FOOTER //
// ./.webpack/px2em.hijack.js